module.exports = __webpack_public_path__ + "img/hat-icon_1.0995b4bc.png";